import { checkIsAuthenticated } from '@/lib/auth'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/auth')({
  validateSearch: z.object({
    redirectTo: z.string().optional(),
  }),
  beforeLoad: async ({ preload, search }) => {
    if (preload) return

    const isAuthenticated = await checkIsAuthenticated()
    if (isAuthenticated) {
      let to = '/'
      if (search.redirectTo && !search.redirectTo.includes('auth')) {
        to = search.redirectTo
      }

      throw redirect({
        from: Route.path,
        to,
      })
    }
  },
  component: Component,
})

function Component() {
  return (
    <div className='flex min-h-lvh items-center justify-center'>
      <Outlet />
    </div>
  )
}
